import React, {useContext} from "react";
import apfelPdf from './apfelPdf'
import { BlobProvider } from "@react-pdf/renderer";
import { UserContext } from 'context/userContext'

function ApfelLink (props){
    const {userProfile} = useContext(UserContext)

    return (
          <BlobProvider key={Math.random()} document={apfelPdf({...userProfile, ...props.ficha, ...props.risk})}>
            {({ url }) => ( <a href={url}
                               target="_blank"
                               rel="noopener noreferrer">
                                {props.link}
                            </a>
            )}
          </BlobProvider>
    )
  }

export default ApfelLink;
